import React, { useState, useRef, useEffect } from 'react';
import { Calendar, Users, BookOpen, Info, X } from 'lucide-react';
import emailjs from '@emailjs/browser';


const App = () => {
  const [currentPage, setCurrentPage] = useState('accueil');
  const [selectedFormation, setSelectedFormation] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formStatus, setFormStatus] = useState('');
  const form = useRef();

  const NavLink = ({ page, icon, children }) => (
    <button 
      onClick={() => {
        const path = page === 'accueil' ? '/' : `/${page}`;
        if (typeof window !== 'undefined') window.history.pushState({}, '', path);
        setCurrentPage(page);
      }}
      className={`flex items-center space-x-2 px-4 py-2 rounded-full transition-all duration-300 ${currentPage === page ? 'bg-indigo-600 text-white shadow-lg' : 'text-gray-600 hover:bg-indigo-100'}`}
    >
      {icon}
      <span>{children}</span>
    </button>
  );

    const sendEmail = (e) => {
    e.preventDefault();
    setFormStatus('sending');

    emailjs.sendForm(
      'service_grfpifn',     
      'template_794a6wo',     
      form.current,
      'sQfkoBU-RS26qerNK'     
    )
    .then(
      (result) => {
        console.log('SUCCESS!', result.text);
        setFormStatus('success');
        setTimeout(() => {
          setIsModalOpen(false);
          setFormStatus('');
          form.current.reset();
        }, 2000);
      },
      (error) => {
        console.log('FAILED...', error.text);
        setFormStatus('error');
      }
    );
  };

  // Reusable Devis form used both in the modal and on the standalone /devis page
  const DevisForm = ({ inline = false }) => (
    <form ref={form} onSubmit={sendEmail} className="space-y-4">
      <div>
        <label htmlFor="from_name" className="block text-sm font-medium text-gray-700 mb-1">
          Nom complet *
        </label>
        <input
          type="text"
          id="from_name"
          name="from_name"
          required
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
      </div>

      <div>
        <label htmlFor="from_email" className="block text-sm font-medium text-gray-700 mb-1">
          Email *
        </label>
        <input
          type="email"
          id="from_email"
          name="from_email"
          required
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
      </div>

      <div>
        <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
          Téléphone
        </label>
        <input
          type="tel"
          id="phone"
          name="phone"
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
      </div>

      <div>
        <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-1">
          Entreprise
        </label>
        <input
          type="text"
          id="company"
          name="company"
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
      </div>

      <div>
        <label htmlFor="formation" className="block text-sm font-medium text-gray-700 mb-1">
          Formation souhaitée
        </label>
        <select
          id="formation"
          name="formation"
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
        >
          <option value="">-- Sélectionner --</option>
          <option value="SST">Formation SST</option>
          <option value="Gestes et Postures">Formation Gestes et Postures</option>
          <option value="Hygiène Alimentaire">Formation Hygiène Alimentaire</option>
          <option value="Document Unique">Formation Document Unique</option>
          <option value="CSSCT initiale plus de 300 sal">Formation initiale CSSCT CSE (partie prévention) 5 Jours, entreprises de plus de 300 salariés</option>
          <option value="CSSCT initiale moins de 300 sal">Formation initiale CSSCT CSE (partie prévention) 5 Jours, entreprises de moins de 300 salariés</option>
          <option value="CSSCT MAC moins de 300 sal">Formation Maintien et actualisation des compétences CSSCT CSE (partie prévention) 3 Jours, entreprises de moins de 300 salariés</option>
          <option value="CSSCT MAC plus de 300 sal">Formation Maintien et actualisation des compétences CSSCT CSE (partie prévention) 5 Jours, entreprises de plus de 300 salariés</option>
           <option value="Autre">Autre</option>
        </select>
      </div>

      <div>
        <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
          Message / Détails de la demande *
        </label>
        <textarea
          id="message"
          name="message"
          rows="4"
          required
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
        ></textarea>
      </div>

      {formStatus === 'success' && (
        <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded-lg">
          Message envoyé avec succès !
        </div>
      )}

      {formStatus === 'error' && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg">
          Erreur lors de l'envoi. Veuillez réessayer.
        </div>
      )}

      <div className="flex gap-3 pt-4">
        {!inline && (
          <button
            type="button"
            onClick={() => setIsModalOpen(false)}
            className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Annuler
          </button>
        )}
        <button
          type="submit"
          disabled={formStatus === 'sending'}
          className="flex-1 px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors disabled:opacity-50"
        >
          {formStatus === 'sending' ? 'Envoi...' : 'Envoyer'}
        </button>
      </div>
    </form>
  );

  const DevisModal = () => {
    if (!isModalOpen) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-xl shadow-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
          <div className="p-6">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-2xl font-bold text-indigo-800">Demande de devis</h3>
              <button
                onClick={() => setIsModalOpen(false)}
                className="text-gray-500 hover:text-gray-700 transition-colors"
              >
                <X size={24} />
              </button>
            </div>

            <form ref={form} onSubmit={sendEmail} className="space-y-4">
              <div>
                <label htmlFor="from_name" className="block text-sm font-medium text-gray-700 mb-1">
                  Nom complet *
                </label>
                <input
                  type="text"
                  id="from_name"
                  name="from_name"
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
              </div>

              <div>
                <label htmlFor="from_email" className="block text-sm font-medium text-gray-700 mb-1">
                  Email *
                </label>
                <input
                  type="email"
                  id="from_email"
                  name="from_email"
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
              </div>

              <div>
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
                  Téléphone
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
              </div>

              <div>
                <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-1">
                  Entreprise
                </label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
              </div>

              <div>
                <label htmlFor="formation" className="block text-sm font-medium text-gray-700 mb-1">
                  Formation souhaitée
                </label>
                <select
                  id="formation"
                  name="formation"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                >
                  <option value="">-- Sélectionner --</option>
                  <option value="SST">Formation SST</option>
                  <option value="Gestes et Postures">Formation Gestes et Postures</option>
                  <option value="Hygiène Alimentaire">Formation Hygiène Alimentaire</option>
                  <option value="Document Unique">Formation Document Unique</option>
                  <option value="CSSCT initiale plus de 300 sal">Formation initiale CSSCT CSE (partie prévention) 5 Jours, entreprises de plus de 300 salariés</option>
                  <option value="CSSCT initiale moins de 300 sal">Formation initiale CSSCT CSE (partie prévention) 5 Jours, entreprises de moins de 300 salariés</option>
                  <option value="CSSCT MAC moins de 300 sal">Formation Maintien et actualisation des compétences CSSCT CSE (partie prévention) 3 Jours, entreprises de moins de 300 salariés</option>
                  <option value="CSSCT MAC plus de 300 sal">Formation Maintien et actualisation des compétences CSSCT CSE (partie prévention) 5 Jours, entreprises de plus de 300 salariés</option>
                   <option value="Autre">Autre</option>
                </select>
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
                  Message / Détails de la demande *
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows="4"
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                ></textarea>
              </div>

              {formStatus === 'success' && (
                <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded-lg">
                  Message envoyé avec succès !
                </div>
              )}

              {formStatus === 'error' && (
                <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg">
                  Erreur lors de l'envoi. Veuillez réessayer.
                </div>
              )}

              <div className="flex gap-3 pt-4">
                <button
                  type="button"
                  onClick={() => setIsModalOpen(false)}
                  className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  Annuler
                </button>
                <button
                  type="submit"
                  disabled={formStatus === 'sending'}
                  className="flex-1 px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors disabled:opacity-50"
                >
                  {formStatus === 'sending' ? 'Envoi...' : 'Envoyer'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  };

  const renderContent = () => {
    // If the URL path is /devis, show the standalone Devis page
    if (typeof window !== 'undefined' && window.location && window.location.pathname === '/devis') {
      return (
        <div className="max-w-3xl mx-auto p-8">
          <h2 className="text-3xl font-bold text-indigo-800 mb-4">Demande de devis</h2>
          <DevisForm inline={true} />
        </div>
      );
    }
    switch(currentPage) {
      case 'formations':
        if (selectedFormation) {
          switch (selectedFormation) {
            case 'SST':
              return <FormationSST onBack={() => setSelectedFormation(null)} />;
            case 'gestesEtPostures':
              return <FormationGestesEtPostures onBack={() => setSelectedFormation(null)} />;
            case 'Hygiene':
              return <FormationHygieneAlimentaire onBack={() => setSelectedFormation(null)} />;
            case 'documentUnique':
              return <FormationdocumentUnique onBack={() => setSelectedFormation(null)} />;
            case 'formationinitialeCSSCTplusde300sal':
              return <FormationinitialeCSSCTplusde300sal onBack={() => setSelectedFormation(null)} />;
              case 'formationinitialeCSSCTmoinsde300sal':
              return <FormationinitialeCSSCTmoinsde300sal onBack={() => setSelectedFormation(null)} />;
              case 'formationMACCSSCTplusde300sal':
              return <FormationMACCSSCTplusde300sal onBack={() => setSelectedFormation(null)} />;
              case 'formationMACCSSCTmoinsde300sal':
              return <FormationMACCSSCTmoinsde300sal onBack={() => setSelectedFormation(null)} />;
            default:
              return null;
          }
        }
        return (
          <div className="space-y-6">
            <div className="flex items-center justify-between">
              <h2 className="text-3xl font-bold text-indigo-800">Nos formations</h2>
              <div className="hidden md:block">
                <button
                  onClick={() => setIsModalOpen(true)}
                  className="bg-indigo-600 text-white px-6 py-2 rounded-full text-base font-semibold hover:bg-indigo-700 transition-all duration-300 shadow-lg hover:shadow-xl"
                >
                  Demander un devis
                </button>
              </div>
            </div>
            {/* Small screens: centered button under title */}
            <div className="text-center md:hidden">
              <button
                onClick={() => setIsModalOpen(true)}
                className="bg-indigo-600 text-white px-8 py-3 rounded-full text-lg font-semibold hover:bg-indigo-700 transition-all duration-300 shadow-lg hover:shadow-xl"
              >
                Demander un devis
              </button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[
              { key: 'formationinitialeCSSCTplusde300sal', name: 'FORMATION INITIALE DES MEMBRES DU CSE ou CSSCT (partie prévention) 5 jours, entreprises de plus de 300 salariés', description: 'Être capable de : Repérer les enjeux de la santé et sécurité au travail. Intégrer la santé et la sécurité au travail dans la gestion de ses missions de membre représentant du personnel. Exercer sa mission de membre représentant du personnel en santé et sécurité au travail.' },
              { key: 'formationinitialeCSSCTmoinsde300sal', name: 'FORMATION INITIALE DES MEMBRES DU CSE ou CSSCT (partie prévention) 5 jours, entreprises de moins de 300 salariés', description: 'Être capable de : Repérer les enjeux de la santé et sécurité au travail. Intégrer la santé et la sécurité au travail dans la gestion de ses missions de membre représentant du personnel. Exercer sa mission de membre représentant du personnel en santé et sécurité au travail.' },
              { key: 'formationMACCSSCTplusde300sal', name: 'MAINTIEN ET ACTUALISATION DES COMPETENCES DES MEMBRES DU CSE ou CSSCT (partie prévention) 5 jours, entreprises de plus de 300 salariés', description: 'Actualiser ses compétences en santé et sécurité au travail et environnementale. Approfondir ses aptitudes à analyser les situations de travail, mener des inspections et enquêtes terrain et rappeler ses missions et moyens en matière de prévention.' },
              { key: 'formationMACCSSCTmoinsde300sal', name: 'MAINTIEN ET ACTUALISATION DES COMPETENCES DES MEMBRES DU CSE ou CSSCT (partie prévention) 3 jours, entreprises de moins de 300 salariés', description: 'Actualiser ses compétences en santé et sécurité au travail et environnementale. Approfondir ses aptitudes à analyser les situations de travail, mener des inspections et enquêtes terrain et rappeler ses missions et moyens en matière de prévention.' },
              { key: 'documentUnique', name: 'Formation Accompagnement à la rédaction du document unique', description: 'Cette formation vous permettra d’acquérir une méthodologie d’évaluation des risques et de retranscrire cette évaluation dans un document.' },
              { key: 'SST', name: 'Formation SST', description: 'Apprenez les gestes de premiers secours en milieu professionnel.' },
              { key: 'gestesEtPostures', name: 'Formation Gestes et Postures', description: 'Optimisez vos postures pour réduire les risques physiques.' },
              { key: 'Hygiene', name: 'Formation Hygiène Alimentaire', description: 'Garantissez la qualité et la sécurité des aliments.' },
            ].map((formation, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300"
              >
                <h3 className="text-xl font-semibold text-indigo-800 mb-2">{formation.name}</h3>
                <p className="text-gray-600 mb-4">{formation.description}</p>
                <button
                  className="bg-indigo-600 text-white px-4 py-2 rounded-full hover:bg-indigo-700 transition-colors duration-300"
                  onClick={() => setSelectedFormation(formation.key)}
                >
                  En savoir plus
                </button>
              </div>
          ))}
            </div>
          </div>
        );
        case 'presentation':
          return (
            <div className="space-y-6 relative">
              <div className="flex justify-between items-start">
                <h2 className="text-3xl font-bold text-indigo-800">
                  Présentation de Valérie GIANGRANDE
                </h2>
                <img
                  src="public\dirigeante.jpg"
                  alt="Portrait de Valérie GIANGRANDE"
                  className="w-32 h-32 rounded-full object-cover shadow-lg"
                />
              </div>
              <p className="text-gray-600 leading-relaxed">
                Originaire du Nord de la France et fille de mineur de fond, Valérie GIANGRANDE a toujours été sensibilisée au maintien de la santé des travailleurs. En août 2023, elle a créé sa société « Santé Travail Solutions » avec pour ambition d’accompagner les entreprises dans la gestion de la santé, de la sécurité, et des conditions de travail des salariés.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Avec plus de 20 ans d’expérience en tant que responsable sécurité dans l’industrie alimentaire et au sein d’une collectivité territoriale, et 8 années comme formatrice pour adultes, elle propose des solutions personnalisées pour répondre aux obligations réglementaires des dirigeants d’entreprises, notamment :
                l’évaluation des risques professionnels physiques et mentaux, la rédaction du document unique, la détermination et le suivi du plan d’actions, l’analyse des accidents de travail, et bien plus encore.
              </p>
              <p className="text-gray-600 leading-relaxed">
                En tant qu’IPRP indépendante, elle collabore étroitement avec les dirigeants pour améliorer les conditions de travail, tout en bénéficiant de l’autonomie et de la diversité qu’offre ce métier. Son engagement reflète sa passion pour le bien-être des travailleurs et l’amélioration des performances des entreprises.
              </p>
              <div className="bg-indigo-100 p-6 rounded-lg shadow-md">
                <h3 className="text-xl font-semibold text-indigo-800 mb-2">Certifications et domaines d'intervention</h3>
                <ul className="list-disc list-inside text-gray-700 space-y-1">
                  <li>Évaluation des risques professionnels et rédaction du document unique</li>
                  <li>Prévention des risques psychosociaux (RPS)</li>
                  <li>Aménagement et accessibilité des ERP</li>
                  <li>Analyse des accidents du travail et maladies professionnelles</li>
                  <li>Sensibilisation et formation en sécurité, hygiène et ergonomie</li>
                </ul>
              </div>
            </div>
          );      
      case 'calendrier':
        return (
            <CalendarComponent onOpenModal={() => setIsModalOpen(true)}/>
        );
      default:
        return (
          <div className="space-y-6">
            <h2 className="text-3xl font-bold text-indigo-800">Bienvenue chez Santé Travail Solutions</h2>
            <div className="text-gray-600 leading-relaxed">

              <p>
                <strong>Santé Travail Solutions</strong>, cabinet conseil dirigé par <strong>Valérie Giangrande</strong> et fondé en juin 2023, propose des prestations de conseil et des formations dans les domaines de la <strong>sécurité au travail</strong> et de l'<strong>hygiène</strong>.
              </p>
              <br/>
              <p>
              <strong>Forte d’une expérience professionnelle de plus de 30 ans</strong>, acquise au sein d’entreprises privées et de collectivités territoriales, je vous accompagne dans les domaines suivants :
              </p>
              <ul className="list-disc ml-6">
                <li>Préservation de la santé et de la sécurité des salariés,</li>
                <li>Amélioration de la qualité de vie au travail (<strong>SQVCT</strong>),</li>
                <li>Sécurité et accessibilité des ERP,</li>
                <li>Hygiène des bâtiments.</li>
              </ul>
              <p>
              <br/>
                <strong>Certifications et enregistrements :</strong>
              </p>
              <ul className="list-disc ml-6">
                <li><strong>IPRP</strong> enregistrée auprès de la <strong>DREETS Bretagne</strong> sous le N° BRET/2023/019,</li>
                <li>Consultante évaluatrice des démarches <strong>QVT</strong> certifiée par <strong>AFNOR</strong> depuis le 9 octobre 2023,</li>
                <li>Référencée sur la plateforme <strong>REFLEX QVT</strong> (<strong>ANACT</strong>).</li>
              </ul>
              <p>
                Passionnée par mon métier, je m’engage à créer un environnement de travail sain, épanouissant et productif pour vos collaborateurs.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {[
                {
                  title: 'Expertise',
                  description:
                    'Profitez de notre expertise pointue dans l’analyse et la gestion des risques professionnels, adaptée à votre secteur.',
                },
                {
                  title: 'Formations',
                  description:
                    'Accédez à des formations complètes et pratiques pour développer vos compétences et celles de votre équipe.',
                },
                {
                  title: 'Accompagnement',
                  description:
                    'Bénéficiez d’un accompagnement personnalisé pour élaborer des solutions sur mesure pour vos besoins spécifiques.',
                },
              ].map((feature, index) => (
                <div key={index} className="bg-indigo-100 p-6 rounded-lg shadow-md">
                  <h3 className="text-xl font-semibold text-indigo-800 mb-2">{feature.title}</h3>
                  <p className="text-gray-700">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        );
    }
  };

  // Keep currentPage in sync with browser history (support /devis direct load and back/forward)
  useEffect(() => {
    const resolvePageFromPath = (pathname) => {
      if (pathname === '/' || pathname === '') return 'accueil';
      if (pathname === '/devis') return 'devis';
      // strip leading slash and return as page name for simple paths used in app
      return pathname.replace(/^\//, '');
    };

    const handlePop = () => {
      if (typeof window !== 'undefined') {
        setCurrentPage(resolvePageFromPath(window.location.pathname));
      }
    };

    // initial sync on mount
    if (typeof window !== 'undefined') {
      setCurrentPage(resolvePageFromPath(window.location.pathname));
    }

    window.addEventListener('popstate', handlePop);
    return () => window.removeEventListener('popstate', handlePop);
  }, [currentPage]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 to-purple-100 py-8 px-4 sm:px-6 lg:px-8 font-sans">
      <div className="max-w-7xl mx-auto">
        <header className="mb-10">
          <h1 className="text-4xl font-bold text-indigo-800 mb-6 text-center">Santé Travail Solutions</h1>
          <nav className="flex flex-wrap justify-center gap-4 items-center">
            <div className="flex items-center gap-4">
              <NavLink page="accueil" icon={<Info size={18} />}>Accueil</NavLink>
              <NavLink page="presentation" icon={<Users size={18} />}>Présentation</NavLink>
              <NavLink page="calendrier" icon={<Calendar size={18} />}>Calendrier</NavLink>
              <NavLink page="formations" icon={<BookOpen size={18} />}>Formations</NavLink>
            </div>
            <div className="ml-4">
              <button
                onClick={() => {
                  // navigate to standalone /devis page
                  if (typeof window !== 'undefined') {
                    window.history.pushState({}, '', '/devis');
                    // trigger a popstate-like render by updating state
                    setCurrentPage('devis');
                  }
                }}
                className="bg-indigo-600 text-white px-4 py-2 rounded-full hover:bg-indigo-700 transition-colors flex items-center gap-2"
              >
                <BookOpen size={16} /> Demander un devis
              </button>
            </div>
          </nav>
        </header>
        <main className="bg-white rounded-xl shadow-2xl p-8 mb-10">
          {renderContent()}
        </main>
        <footer className="text-center text-gray-500">
          <p>&copy; 2024 Santé Travail Solutions. Tous droits réservés.</p>
        </footer>
      </div>
      <DevisModal />
    </div>
  );
};

// Composants pour les pages détaillées de chaque formation
const FormationSST = ({ onBack }) => (
  <div className="space-y-6">
    <h2 className="text-3xl font-bold text-indigo-800">Formation SST (Sauveteur Secouriste du Travail)</h2>
    <p className="text-gray-600">La formation initiale de Sauveteur Secouriste du Travail (SST) permet au salarié formé d'intervenir rapidement et efficacement lors d'une situation d'accident du travail dans l'établissement ou dans la profession.</p>
    <h3 className="text-2xl font-semibold text-indigo-700">Déroulé de la formation</h3>
    <ul className="list-disc list-inside space-y-2 text-gray-700">
      <li>Situer le cadre juridique de son intervention</li>
      <li>Réaliser une protection adaptée</li>
      <li>Examiner la victime</li>
      <li>Faire alerter ou alerter</li>
      <li>Secourir la victime de manière appropriée</li>
      <li>Situer son rôle de SST dans l'organisation de la prévention de l'entreprise</li>
      <li>Contribuer à la mise en œuvre d'actions de prévention</li>
      <li>Informer les personnes désignées dans le plan d'organisation de la prévention de l'entreprise de la/des situation(s) dangereuse(s) repérée(s)</li>
    </ul>
    <div className="bg-indigo-100 p-4 rounded-lg">
      <h4 className="text-xl font-semibold text-indigo-800 mb-2">Informations pratiques</h4>
      <p className="text-gray-700">Durée : 14 heures</p>
      <p className="text-gray-700">Validité : Certificat valable 24 mois</p>
    </div>
    <button onClick={onBack} className="bg-indigo-600 text-white px-4 py-2 rounded-full hover:bg-indigo-700 transition-colors duration-300">
      Retour
    </button>
  </div>
);

const FormationGestesEtPostures = ({ onBack }) => (
  <div className="space-y-6">
    <h2 className="text-3xl font-bold text-indigo-800">Formation Gestes et Postures</h2>
    <p className="text-gray-600">La formation en gestes et postures est conçue pour réduire les risques d'accidents et maladies professionnels liés à l'activité physique au travail.</p>
    <h3 className="text-2xl font-semibold text-indigo-700">Contenu de la formation</h3>
    <ul className="list-disc list-inside space-y-2 text-gray-700">
      <li>Apprendre les techniques de soulèvement correctes</li>
      <li>Comprendre l'importance de l'ergonomie au travail</li>
      <li>Pratiquer des exercices de prévention des blessures</li>
      <li>Identifier et corriger les postures nuisibles</li>
    </ul>
    <div className="bg-indigo-100 p-4 rounded-lg">
      <h4 className="text-xl font-semibold text-indigo-800 mb-2">Informations pratiques</h4>
      <p className="text-gray-700">Durée : 7 heures </p>
      <p className="text-gray-700">Public : Tous les employés exposés à des risques ergonomiques</p>
    </div>
    <button onClick={onBack} className="bg-indigo-600 text-white px-4 py-2 rounded-full hover:bg-indigo-700 transition-colors duration-300">
      Retour
    </button>
  </div>
);

const FormationHygieneAlimentaire = ({ onBack }) => (
  <div className="space-y-6">
    <h2 className="text-3xl font-bold text-indigo-800">Formation Hygiène Alimentaire</h2>
    <p className="text-gray-600">Essentielle pour les professionnels de la restauration, cette formation garantit la sécurité et la qualité alimentaires conformément aux normes en vigueur.</p>
    <h3 className="text-2xl font-semibold text-indigo-700">Points clés de la formation</h3>
    <ul className="list-disc list-inside space-y-2 text-gray-700">
      <li>Comprendre les fondamentaux de l'hygiène alimentaire</li>
      <li>Appliquer les principes de la méthode HACCP</li>
      <li>Prévenir les contaminations et les intoxications alimentaires</li>
      <li>Maintenir un environnement de travail propre et sûr</li>
    </ul>
    <div className="bg-indigo-100 p-4 rounded-lg">
      <h4 className="text-xl font-semibold text-indigo-800 mb-2">Informations pratiques</h4>
      <p className="text-gray-700">Durée : 14 heures</p>
      <p className="text-gray-700">Public : Professionnels de la restauration</p>
    </div>
    <button onClick={onBack} className="bg-indigo-600 text-white px-4 py-2 rounded-full hover:bg-indigo-700 transition-colors duration-300">
      Retour
    </button>
  </div>
);

const FormationdocumentUnique = ({ onBack }) => (
  <div className="space-y-6">
    <h2 className="text-3xl font-bold text-indigo-800">Formation Accompagnement à la rédaction du document unique</h2>
    <p className="text-gray-600">
      Le document unique est un document obligatoire issu de l’évaluation des risques professionnels de votre entreprise. 
      Cette formation vous permettra d’acquérir une méthodologie d’évaluation des risques et de retranscrire cette évaluation dans un document.
    </p>
    <h3 className="text-2xl font-semibold text-indigo-700">Points clés de la formation</h3>
    <ul className="list-disc list-inside space-y-2 text-gray-700">
      <li>Connaitre la réglementation applicable et les enjeux</li>
      <li>Connaitre les différents types de risques selon l’INRS</li>
      <li>Evaluer les risques au sein de vos unités de travail</li>
      <li>Hiérarchiser les risques pour construire son plan d’actions (ou PAPRIPACT)</li>
    </ul>
    <div className="bg-indigo-100 p-4 rounded-lg">
      <h4 className="text-xl font-semibold text-indigo-800 mb-2">Informations pratiques</h4>
      <p className="text-gray-700">Durée : 14 heures</p>
      <p className="text-gray-700">
        Public : Responsable RH, secrétaire de direction, Salarié désigné compétent, assistant de prévention…
      </p>
    </div>
    <button
      onClick={onBack}
      className="bg-indigo-600 text-white px-4 py-2 rounded-full hover:bg-indigo-700 transition-colors duration-300"
    >
      Retour
    </button>
  </div>
);
const FormationinitialeCSSCTplusde300sal = ({ onBack }) => (
  <div className="space-y-6">
    <h2 className="text-3xl font-bold text-indigo-800">FORMATION INITIALE DES MEMBRES DU CSE ou CSSCT (partie prévention) 
5 jours, entreprises de plus de 300 salariés</h2>
    <p className="text-gray-600">
      -	Repérer les enjeux de la santé sécurité au travail
      -	Intégrer la santé et la sécurité au travail dans la gestion de ses missions de membre représentant du personnel en santé et sécurité au travail 
      -	Exercer sa mission de membre représentant du personnel en santé et sécurité au travail
    </p>
    <h3 className="text-2xl font-semibold text-indigo-700">Points clés de la formation</h3>
    <ul className="list-disc list-inside space-y-2 text-gray-700">
      <li>Exercer sa mission de membre du CSE ou CSSCT</li>
      <li>Participer à l'observation de la santé dans l'entreprise</li>
      <li>Communiquer avec les acteurs de la prévention internes et externes</li>
      <li>Mener des inspections et enquêtes terrain en prévention des risques professionnels (retours d’expérience + apports de connaissances)</li>
      <li>Identifier la SST comme levier de performance de l’entreprise</li>
      <li>Identifier les dangers et les situations de travail dangereuses</li>
      <li>Supprimer ou réduire ces risques professionnels</li>
      <li>Le DU et le plan d’actions (PAPRIPACT)</li>
      <li>Evaluation d'une unité de travail en se basant sur le DUERP</li>
    </ul>
    <div className="bg-indigo-100 p-4 rounded-lg">
      <h4 className="text-xl font-semibold text-indigo-800 mb-2">Informations pratiques</h4>
      <p className="text-gray-700">Durée : 35 heures</p>
      <p className="text-gray-700">
        Public : Membre élu du CSE CSSCT 
      </p>
    </div>
    <button
      onClick={onBack}
      className="bg-indigo-600 text-white px-4 py-2 rounded-full hover:bg-indigo-700 transition-colors duration-300"
    >
      Retour
    </button>
  </div>
);

const FormationinitialeCSSCTmoinsde300sal = ({ onBack }) => (
  <div className="space-y-6">
    <h2 className="text-3xl font-bold text-indigo-800">FORMATION INITIALE DES MEMBRES DU CSE ou CSSCT (partie prévention) 
5 jours, entreprises de moins de 300 salariés</h2>
    <p className="text-gray-600">
      -	Repérer les enjeux de la santé sécurité au travail
      -	Intégrer la santé et la sécurité au travail dans la gestion de ses missions de membre représentant du personnel en santé et sécurité au travail 
      -	Exercer sa mission de membre représentant du personnel en santé et sécurité au travail
    </p>
    <h3 className="text-2xl font-semibold text-indigo-700">Points clés de la formation</h3>
    <ul className="list-disc list-inside space-y-2 text-gray-700">
      <li>Exercer sa mission de membre du CSE ou CSSCT</li>
      <li>Participer à l'observation de la santé dans l'entreprise</li>
      <li>Communiquer avec les acteurs de la prévention internes et externes</li>
      <li>Mener des inspections et enquêtes terrain en prévention des risques professionnels (retours d’expérience + apports de connaissances)</li>
      <li>Identifier la SST comme levier de performance de l’entreprise</li>
      <li>Identifier les dangers et les situations de travail dangereuses</li>
      <li>Supprimer ou réduire ces risques professionnels</li>
      <li>Le DU et le plan d’actions (PAPRIPACT)</li>
      <li>Evaluation d'une unité de travail en se basant sur le DUERP</li>
    </ul>
    <div className="bg-indigo-100 p-4 rounded-lg">
      <h4 className="text-xl font-semibold text-indigo-800 mb-2">Informations pratiques</h4>
      <p className="text-gray-700">Durée : 35 heures</p>
      <p className="text-gray-700">
        Public : Membre élu du CSE CSSCT 
      </p>
    </div>
    <button
      onClick={onBack}
      className="bg-indigo-600 text-white px-4 py-2 rounded-full hover:bg-indigo-700 transition-colors duration-300"
    >
      Retour
    </button>
  </div>
);

const FormationMACCSSCTmoinsde300sal = ({ onBack }) => (
  <div className="space-y-6">
    <h2 className="text-3xl font-bold text-indigo-800">MAINTIEN ET ACTUALISATION DES COMPETENCES DES MEMBRES DU CSE ou CSSCT (partie prévention) 
3 jours, entreprises de moins de 300 salariés</h2>
    <p className="text-gray-600">
      -	Actualiser ses compétences en santé sécurité au travail et environnementale et se perfectionner
      -	Approfondir ses aptitudes à analyser les situations de travail, mener des inspections et enquêtes terrain
      -	Rappeler ses missions et moyens de membre représentant du personnel en santé et sécurité au travail
    </p>
    <h3 className="text-2xl font-semibold text-indigo-700">Points clés de la formation</h3>
    <ul className="list-disc list-inside space-y-2 text-gray-700">
      <li>Actualiser ses connaissances du cadre réglementaire et normatif</li>
      <li>Renforcer les compétences en prévention des risques professionnels</li>
      <li>Communiquer avec les acteurs de la prévention internes et externes</li>
      <li>Mener des inspections et enquêtes terrain en prévention des risques professionnels (retours d’expérience + apports de connaissances)</li>
      <li>Le maintien au travail, la lutte contre la désinsertion professionnelle</li>
      <li>Décrire les modalités de positionnement rencontrées en tant que représentant de l’ensemble des salariés</li>
      <li>Améliorer sa communication et sa posture en réunion</li>
    </ul>
    <div className="bg-indigo-100 p-4 rounded-lg">
      <h4 className="text-xl font-semibold text-indigo-800 mb-2">Informations pratiques</h4>
      <p className="text-gray-700">Durée : 21 heures</p>
      <p className="text-gray-700">
        Public : Membre élu du CSE CSSCT ayant déjà suivi la formation initiale
      </p>
    </div>
    <button
      onClick={onBack}
      className="bg-indigo-600 text-white px-4 py-2 rounded-full hover:bg-indigo-700 transition-colors duration-300"
    >
      Retour
    </button>
  </div>
);

const FormationMACCSSCTplusde300sal = ({ onBack }) => (
  <div className="space-y-6">
    <h2 className="text-3xl font-bold text-indigo-800">MAINTIEN ET ACTUALISATION DES COMPETENCES DES MEMBRES DU CSE ou CSSCT (partie prévention) 
5 jours, entreprises de plus de 300 salariés</h2>
    <p className="text-gray-600">
      -	Actualiser ses compétences en santé sécurité au travail et environnementale et se perfectionner
      -	Approfondir ses aptitudes à analyser les situations de travail, mener des inspections et enquêtes terrain
      -	Rappeler ses missions et moyens de membre représentant du personnel en santé et sécurité au travail
    </p>
    <h3 className="text-2xl font-semibold text-indigo-700">Points clés de la formation</h3>
    <ul className="list-disc list-inside space-y-2 text-gray-700">
      <li>Actualiser ses connaissances du cadre réglementaire et normatif</li>
      <li>Renforcer les compétences en prévention des risques professionnels</li>
      <li>Communiquer avec les acteurs de la prévention internes et externes</li>
      <li>Mener des inspections et enquêtes terrain en prévention des risques professionnels (retours d’expérience + apports de connaissances)</li>
      <li>Le maintien au travail, la lutte contre la désinsertion professionnelle</li>
      <li>Décrire les modalités de positionnement rencontrées en tant que représentant de l’ensemble des salariés</li>
      <li>Améliorer sa communication et sa posture en réunion</li>
    </ul>
    <div className="bg-indigo-100 p-4 rounded-lg">
      <h4 className="text-xl font-semibold text-indigo-800 mb-2">Informations pratiques</h4>
      <p className="text-gray-700">Durée : 35 heures</p>
      <p className="text-gray-700">
        Public : Membre élu du CSE CSSCT ayant déjà suivi la formation initiale
      </p>
    </div>
    <button
      onClick={onBack}
      className="bg-indigo-600 text-white px-4 py-2 rounded-full hover:bg-indigo-700 transition-colors duration-300"
    >
      Retour
    </button>
  </div>
);

const CalendarComponent = ({ onOpenModal }) => {
  return (
    <div className="space-y-6">
      <div className="mt-8 bg-white rounded-lg shadow-xl p-6">
        <h2 className="text-3xl font-bold text-indigo-800 mb-4">Calendrier des formations</h2>
        <div className="w-full">
          <iframe 
            title='google-agenda'
            src="https://calendar.google.com/calendar/embed?src=91d135733d354ba0085d593eb6dac6eda9edea157b5e678f65c7623657ed05bb%40group.calendar.google.com&ctz=Europe%2FParis"            style={{ border: 0 }}
            width="100%"
            height="600"
            frameBorder="0"
            scrolling="no"
            className="rounded-lg"
          />
        </div>
      </div>
      
      <div className="text-center">
        <button
          onClick={onOpenModal}
          className="bg-indigo-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-indigo-700 transition-all duration-300 shadow-lg hover:shadow-xl"
        >
          Demander un devis
        </button>
      </div>
    </div>
  );
};

export default App;
